import { Navigate } from 'react-router-dom'
import { useAuth } from '@/contexts/AuthContextSupabase'
import { ProgressSpinner } from 'primereact/progressspinner'
import styles from './ProtectedRoute.module.css'

export function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth()

  if (loading) {
    return (
      <div className={styles.loadingContainer}>
        <div className={styles.loadingContent}>
          <ProgressSpinner
            style={{ width: '60px', height: '60px' }}
            strokeWidth="4"
          />
          <p className={styles.loadingText}>認証中...</p>
        </div>
      </div>
    )
  }

  if (!user) {
    return <Navigate to="/login" replace />
  }

  return <>{children}</>
}
